/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus200,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus401,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus404,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus500,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusPathParams,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusQueryParams,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusQueryResponse,
} from "../../types/courseRegistrationAssociatedCompanyDocumentApprovalController/GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus.ts";
import { associatedCompanyDocumentApprovalStatusViewModelSchema } from "../associatedCompanyDocumentApprovalStatusViewModelSchema.ts";

export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    associatedCompanyDocumentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusPathParams>;

export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusQueryParamsSchema =
  z
    .object({
      attachmentId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus200Schema =
  z.lazy(
    () => associatedCompanyDocumentApprovalStatusViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus500>;

export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusQueryResponse>;
